"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTopHeader = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var AcTopHeader_module_scss_1 = __importDefault(require("./AcTopHeader.module.scss"));
var AcTopHeader = function (_a) {
    var _b;
    var negativeMargin = _a.negativeMargin, title = _a.title, leading = _a.leading, trailing = _a.trailing, wrappable = _a.wrappable, children = _a.children, titleClassName = _a.titleClassName;
    var renderTitle = function (titleClassName) {
        if (typeof title === 'string') {
            return react_1.default.createElement("h1", { className: clsx_1.default('h1 text-nowrap mb-0 pr-4', titleClassName) }, title);
        }
        return title;
    };
    return (react_1.default.createElement("div", { className: clsx_1.default((_b = {
                'bg-white d-flex flex-row align-items-center': true
            },
            _b[AcTopHeader_module_scss_1.default.wrappable] = wrappable,
            _b[AcTopHeader_module_scss_1.default.topheader] = true,
            _b[AcTopHeader_module_scss_1.default.negativemargin] = negativeMargin,
            _b)) },
        leading && react_1.default.createElement("div", { className: "pr-4" }, leading),
        renderTitle(titleClassName),
        children && react_1.default.createElement("div", { className: "flex-grow-1" }, children),
        trailing && react_1.default.createElement("div", { className: "ml-auto pl-4" }, trailing)));
};
exports.AcTopHeader = AcTopHeader;
exports.AcTopHeader.displayName = 'AcTopHeader';
//# sourceMappingURL=AcTopHeader.js.map